export const convertCelsiusToFahrenheit = (temp) => {
  if (temp == null) return null;
  if (temp) {
    return Math.round(temp * (9 / 5) + 32);
  }
  return 0;
};

export const convertFahrenheitToCelsius = (temp) => {
  if (temp == null) return null;
  if (temp) {
    return (temp - 32) * (5 / 9);
  }
  return 0;
};

export const calculateTotalEnergyConsumption = (value, swtName, isF) => {
  const consumptionGas = isF ? value : Math.round(value * 0.0283168);
  const consumption = swtName === 'tgs' ? consumptionGas : value;
  return consumption ?? '--';
};

export const getConsumptionValue = (swtName, value, isF) => {
  return swtName === 'tgs'
    ? Math.round((isF ? value : value * 0.0283168) * 10) / 10
    : Math.round(value * 10) / 10;
};
